import SelectBox from 'devextreme-react/select-box';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Modal } from 'semantic-ui-react';
import { userApi } from '../../../api/userApi';
import { DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
const PhuHuynhSelectTuVanVienModal = ({ onCancel, onSelected, tuVanViens }) => {
	const [tvvs, setTvvs] = useState([]);
	const [value, setValue] = useState(0);
	const { translate } = useCommonContext();
	const { dm_coso_id } = useSelector(x => x.coSo)

	useEffect(() => {
		hanleLoadTuVanViens();
	}, []);
	const hanleLoadTuVanViens = async () => {
		const res = await userApi.SelectTuVanVien(dm_coso_id);
		if (res.is_success) {
			setTvvs(res.data);
		}
	};
	return (
		<>
			<Modal
				open={true}
				size='mini'
				dimmer={'blurring'}
				onClose={onCancel}
				closeOnEscape={false}
				closeOnDimmerClick={false}
			>
				<Modal.Header>
					<p>Chọn tư vấn viên</p>
				</Modal.Header>
				<Modal.Content>
					<form className='ui'>
						<div className='row'>
							<div className='col-md-12 padding-top-1rem'>
								<p>Chọn Tư vấn viên</p>
								<SelectBox
									dataSource={tvvs}
									displayExpr={'full_name'}
									valueExpr={'id'}
									value={value}
									stylingMode='outlined'
									readOnly={false}
									placeholder={translate('Chọn Tư vấn viên')}
									width='100%'
									searchEnabled
									showClearButton
									onValueChanged={(e) => {
										console.log(tuVanViens);
										if (e.event) setValue(e.value || 0);
									}}
								/>
							</div>
						</div>
					</form>
				</Modal.Content>
				<Modal.Actions>
					<div>
						<DefaultButton text={'Đóng'} onClick={onCancel} />
						<PrimaryButton
							text={'Cập nhật'}
							onClick={() => {
								onSelected(value);
							}}
						/>
					</div>
				</Modal.Actions>
			</Modal>
		</>
	);
};

export default PhuHuynhSelectTuVanVienModal;
